import { render, staticRenderFns } from "./SSOFieldTags.vue?vue&type=template&id=70e90acf&"
import script from "./SSOFieldTags.vue?vue&type=script&lang=js&"
export * from "./SSOFieldTags.vue?vue&type=script&lang=js&"
import style0 from "./SSOFieldTags.vue?vue&type=style&index=0&id=70e90acf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports